import { Home06Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Show } from "shared/components";
import { formatToCurrency } from "shared/utils/currency";
import { Section } from "views/applications-id-report/components/Section";
import { Row } from "views/applications-id-report/components/Row";
import { SectionIcon } from "../components/SectionIcon";
import { PurchaseInfo } from "../types";
import { formatLabel } from "../utils";

export const HomeDetailsSlice = ({ loan }: { loan: PurchaseInfo }) => {
  const dimensions =
    loan.houseLength && loan.houseWidth
      ? `${loan.houseLength}' × ${loan.houseWidth}'`
      : "";

  return (
    <Section
      sectionTitle="Home details"
      icon={<SectionIcon icon={Home06Icon} />}
    >
      <div className="space-y-2">
        <Row title="Manufacturer" value={loan.manufacturer} />
        <Row title="Model" value={loan.homeModel} />
        <Row title="Serial number" value={loan.homeSerial} />
        <Row title="Year built" value={String(loan.yearBuilt)} />
        <Row title="Dimensions" value={dimensions} />
        <Row title="Condition" value={formatLabel(loan.homeConditionType)} />
        <Row title="Land type" value={formatLabel(loan.landType)} />
        <Show if={loan.landType === "leased_land"}>
          <Row title="Lot rent" value={formatToCurrency(loan.lotRent)} />
        </Show>
      </div>
    </Section>
  );
};
